// @flow
import LocationModel from "src/models/LocationModel";
import { entityReducer } from "src/utils/reducerUtils";

export const locations = entityReducer({
  name: "locations",
  Model: LocationModel
});
